import { SE_DA } from "./seDa.js";
export * from "./typen.js";
export * from "./preisebenen.js";
export * from "./pruefung.js";
export * from "./eingaben.js";
export { SE_DA } from "./seDa.js";
/** Alle Nähateliers. Ein neues Atelier ist ein neues Modul hier – angelegt wird nur im Code. */
export const ATELIERS = [SE_DA];
export function atelierModul(schluessel) {
    return ATELIERS.find((m) => m.schluessel === schluessel);
}
//# sourceMappingURL=index.js.map